import { AnalysisResult } from "@/redux/feature/videoDashboard/videoDashboardType";
import { Play } from "lucide-react";

const StoryboardAnalysis: React.FC<{
  data: AnalysisResult["storyboard_analysis"];
}> = ({ data }) => (
  <div className="bg-white rounded-lg border border-gray-200 p-6">
    <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
      <Play className="w-5 h-5" />
      Storyboard Analysis
    </h3>

    <div className="space-y-6">
      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <span className="text-sm font-medium text-gray-900">Artist Notes</span>
        <p className="text-sm text-gray-600 mt-2 leading-relaxed">
          {data.artist_notes}
        </p>
      </div>

      <div>
        <span className="text-sm font-medium text-gray-900">Overview</span>
        <p className="text-sm text-gray-600 mt-2 leading-relaxed">
          {data.storyboard_description}
        </p>
      </div>

      <div>
        <span className="text-sm font-medium text-gray-900">
          Technical Summary
        </span>
        <p className="text-sm text-gray-600 mt-2 leading-relaxed">
          {data.technical_summary}
        </p>
      </div>

      <div>
        <span className="text-sm font-medium text-gray-900 mb-3 block">
          Technical Breakdown
        </span>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {Object.entries(data.technical_summary_breakdown).map(
            ([key, value]) => (
              <div key={key} className="bg-gray-50 rounded-md p-3">
                <span className="text-xs font-medium text-gray-900 capitalize">
                  {key.replace("_", " ")}
                </span>
                <p className="text-xs text-gray-600 mt-1">{value}</p>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  </div>
);

export default StoryboardAnalysis;
